package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.ClosingSoonDTO
import gr.tech.meetinggenie.models.meeting.ConfidenceLevel
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun ClosingSoonTableInput(
    closingSoon: List<ClosingSoonDTO>,
    onUpdate: (List<ClosingSoonDTO>) -> Unit,
) {
    DraggableDataTable(
        rowCount      = closingSoon.size,
        onMove        = { from, to -> onUpdate(closingSoon.toMutableList().also { it.add(to, it.removeAt(from)) }) },
        onDelete      = { index   -> onUpdate(closingSoon.toMutableList().also { it.removeAt(index) }) },
        addButtonText = "Add Project",
        onAdd         = { onUpdate(closingSoon + ClosingSoonDTO()) },
        headers = {
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Account / Project Name") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(140.px).toAttrs()) { Text("Expected Close Date") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(130.px).toAttrs()) { Text("Confidence Level") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(200.px).toAttrs()) { Text("What needs to happen next?") }
        },
        rowCells = { index ->
            val item = closingSoon[index]

            // Account / Project Name
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = item.accountName,
                    onInput = { v -> onUpdate(closingSoon.toMutableList().also { it[index] = it[index].copy(accountName = v) }) }
                )
            }

            // Expected Close Date — native date picker
            Td(DataEntryCellStyle.toModifier().minWidth(140.px).padding(4.px).toAttrs()) {
                Input(
                    type = InputType.Date,
                    attrs = TableSelectStyle.toModifier().toAttrs {
                        value(item.expectedCloseDate)
                        onInput { event ->
                            onUpdate(closingSoon.toMutableList().also { it[index] = it[index].copy(expectedCloseDate = event.value) })
                        }
                    }
                )
            }

            // Confidence Level — radio
            Td(DataEntryCellStyle.toModifier().minWidth(130.px).padding(4.px).toAttrs()) {
                Column(verticalArrangement = Arrangement.spacedBy(4.px)) {
                    ConfidenceLevel.entries.forEach { option ->
                        Label(attrs = RadioOptionLabelStyle.toModifier().toAttrs()) {
                            Input(
                                type = InputType.Radio,
                                attrs = RadioInputStyle.toModifier().toAttrs {
                                    id("confidence-$index-${option.name}")
                                    attr("name", "confidence-$index")
                                    checked(item.confidenceLevel == option)
                                    onClick {
                                        onUpdate(closingSoon.toMutableList().also { it[index] = it[index].copy(confidenceLevel = option) })
                                    }
                                }
                            )
                            Text(option.label)
                        }
                    }
                }
            }

            // What needs to happen next?
            Td(DataEntryCellStyle.toModifier().minWidth(200.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = item.whatHappensNext,
                    onInput = { v -> onUpdate(closingSoon.toMutableList().also { it[index] = it[index].copy(whatHappensNext = v) }) }
                )
            }
        }
    )
}
